/**
 * @desc 创建研发物品
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ResearchItemCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/createResearchItem`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
